import { Paper, Theme, Typography } from "@yuno/design-system-web";
import { useIsTesting } from "@yuno/dashboard-container-mfe";
import styled from "@emotion/styled";
import { SidebarNav } from "./sidebar-nav";
import { useTranslation } from "react-i18next";

const Container = styled(Paper)<{ isTesting?: boolean; theme?: Theme }>`
  width: 126px;
  height: ${({ isTesting }) => (isTesting ? "83.55vh" : "87.5vh")};
  border-radius: 0;
  border-right: 1px solid ${({ theme }) => theme.palette.grey[2]};
  padding-top: 20px;
  padding-left: 10px;
  padding-right: 10px;
`;

const Title = styled(Typography)<{ theme?: Theme }>`
  ${({ theme }) => theme.typography.tiny.regular};
  color: ${({ theme }) => theme.palette.neutral.black};
  margin-bottom: 20px;
`;

export const Sidebar = function () {
  const { t } = useTranslation();
  const { isTesting } = useIsTesting();

  return (
    <Container isTesting={isTesting}>
      <Title>{t('pages')}</Title>
      <SidebarNav />
    </Container>
  );
};
